<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-primary card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">login</i>
				</div>
				<h3 class="card-title">{{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<div class="customers-online-toolbar mb-2">
					<button class="btn btn-success btn-sm" (click)="exportXlsx()" [disabled]="!displayData?.length" title="Export XLSX"><i class="fa fa-file-excel-o"></i></button>
					<button class="btn btn-danger btn-sm ms-1" (click)="exportPdf()" [disabled]="!displayData?.length" title="Export PDF"><i class="fa fa-file-pdf-o"></i></button>
					<input type="text" class="form-control form-control-sm customers-online-search-input" placeholder="Filter table…" [(ngModel)]="searchTerm" (ngModelChange)="applySearch()" />
				</div>
				<div class="table-responsive" #print_table>
					<table class="table table-sm table-hover customers-online-table">
						<thead>
							<tr>
								<th>IP</th>
								<th>Customer#</th>
								<th>Branch#</th>
								<th>Name</th>
								<th>Address</th>
								<th>City</th>
								<th>Region</th>
								<th>Postal#</th>
								<th>Phone#</th>
								<th>Cart#</th>
								<th>Qty</th>
								<th class="customers-online-lastseen">Last seen</th>
								<th>URL</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let d of displayData">
								<td class="text-nowrap">{{ d.ip || '—' }}</td>
								<td class="text-nowrap">{{ d.custID ?? '—' }}</td>
								<td class="text-nowrap">{{ d.branchcode || '—' }}</td>
								<td class="customers-online-name">{{ d.brname || '—' }}</td>
								<td class="customers-online-address">{{ d.braddress1 || '—' }}</td>
								<td class="text-nowrap">{{ d.braddress3 || '—' }}</td>
								<td class="text-nowrap">{{ d.braddress4 || '—' }}</td>
								<td class="text-nowrap">{{ d.braddress5 || '—' }}</td>
								<td class="text-nowrap">{{ d.phoneno || '—' }}</td>
								<td class="text-nowrap">{{ d.cart_id ?? '—' }}</td>
								<td class="text-nowrap">{{ d.quantity ?? '—' }}</td>
								<td class="text-nowrap customers-online-lastseen">{{ d.custDate || '—' }}</td>
								<td class="customers-online-url"><a *ngIf="d.url" [href]="d.url" target="_blank" rel="noopener" [title]="d.url">{{ d.url }}</a><span *ngIf="!d.url">—</span></td>
							</tr>
							<tr *ngIf="displayData?.length === 0 && data">
								<td colspan="14" class="text-center text-muted py-3">No rows match your search.</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-primary card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(data, title)">
					<i class="material-icons">login</i>
				</div>
				<p class="card-category">{{ title }}</p>
				<h3 class="card-title">
					<span *ngIf="data">{{ data.length }}</span>
					<span *ngIf="!data">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
				<small>
					<p class="card-category text-info text-justify mt-3 text-right">&nbsp;</p>
				</small>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(data, title)">
						<i class="material-icons">content_copy</i>
						View Now
					</a>
				</div>
				<br />
			</div>
		</div>
	</div>
</div>
